module.exports = require("dyna-object-scan");